import { useActiveConversation } from '../components/chat/ActiveConversationContext';
import { useChatFilePane } from './chat-file-pane';
import { useChatOverlayOpen } from './use-chat-overlay';
import { useChatsLayout } from './use-chats-layout';
import { useNarrow } from './use-narrow';
import { useSitePane } from './use-site-pane';
import { useEmailReviewPane } from './email-review-pane';
import { useBlogReviewPane } from './blog-review-pane';
import { useDraftReviewPane } from './draft-review-pane';

/**
 * True when the open chat paints as the side-DOCKED column that PUSHES the content pane — AppFrame's
 * `--chat-w` follows exactly this, and FloatingChat paints its docked `dockWidth` column under the same
 * condition (`open && !narrow && !fullscreen`, not on a stacked /chats). One expression for both, so a page
 * that reacts to the dock (the Overview canvas slides its dock in beside it) never disagrees with the pane.
 *
 * A file docked beside the chat (`useChatFilePane`) grows the chat over the whole content area, the way
 * fullscreen does, so it reserves no dock column either — FloatingChat's `docked` carries the same term.
 * A Symphony site's preview pane splits the chat the same way (`lib/use-site-pane.ts`).
 *
 * Its own module rather than `use-chat-overlay`: both panes' hooks import that one.
 */
export function useChatDocked(): boolean {
  const open = useChatOverlayOpen();
  const narrow = useNarrow();
  const { stacked } = useChatsLayout();
  const { chatMode } = useActiveConversation();
  const chatFilePane = useChatFilePane();
  const sitePane = useSitePane();
  const emailPane = useEmailReviewPane();
  const blogPane = useBlogReviewPane();
  const draftPane = useDraftReviewPane();
  return !stacked && !narrow && open && chatMode !== 'fullscreen' && !chatFilePane && !sitePane && !emailPane && !blogPane && !draftPane;
}
